export const mainCls = 'spinner';

export default {
    [mainCls]: {
        display: 'inline-block',
        borderBottomColor: 'transparent !important',
        borderRightColor: 'transparent !important',
        animation: 'spin .4s linear infinite',
        opacity: 0.5,
    },
    [`${mainCls}__wrp--vac`]: {
        display: 'flex',
        alignItems: 'center',
    },
    [`${mainCls}__wrp--inl`]: {
        display: 'inline-block',
    },
    [`${mainCls}__no-opacity`]: {
        opacity: 1,
    },
}